import React from 'react';
import { bool, shape, string } from 'prop-types';

const UnsetOperation = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 4.5H9L7.5 3H3C2.175 3 1.5 3.675 1.5 4.5V13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V6C16.5 5.175 15.825 4.5 15 4.5ZM15 13.5H3V4.5H6.8775L8.3775 6H15V13.5ZM9.12 9H6V10.5H9.12L7.9275 11.6925L8.9925 12.75L12 9.7575L8.9925 6.75L7.935 7.8075L9.12 9Z" fill="currentColor" />
  </svg>
);

UnsetOperation.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default UnsetOperation;
